/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { ILabDepartmentItem } from 'app/shared/model/lab-department-item.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IDiaglabDepartmentAccess {
  id?: string;
  active?: boolean;
  lastUpdated?: number;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  userId?: string | null;
  userRole?: keyof typeof AddedByType | null;
  diagLab?: IDiagLab | null;
  department?: ILabDepartmentItem | null;
}

export const defaultValue: Readonly<IDiaglabDepartmentAccess> = {
  active: false,
};
